import React, { useContext } from 'react'

import { DepthKeys, useLanguages } from '@/hooks'
import { Select } from '@/components'

import { FleetContext } from './context'

const classTypes: {
  label: DepthKeys
  value: 'cars' | 'vans' | 'suvs'
}[] = [
  {
    label: 'cars',
    value: 'cars',
  },
  {
    label: 'suvS',
    value: 'suvs',
  },
  {
    label: 'vans',
    value: 'vans',
  },
]

const passengers: {
  label: string
  value: 4 | 5 | 7
}[] = [
  {
    label: '4+',
    value: 4,
  },
  {
    label: '5+',
    value: 5,
  },
  {
    label: '7+',
    value: 7,
  },
]

export const Sidebar: React.FC = () => {
  const { t } = useLanguages()
  const {
    onSelect,
    transmission,
    vehicleClasses,
    passengers: passengersFilter,
  } = useContext(FleetContext)

  return (
    <div className="column small-12 medium-4 large-3">
      <aside className="theme--dark-blue2 white-color">
        <div className="filters_header">
          <h2>{t('filtersTitle')}</h2>
        </div>
        <div className="filters">
          <div className="filters_item">
            <h3>{t('vehicleClass')}</h3>
            <div>
              {classTypes.map(type => (
                <Checkbox
                  key={type.value}
                  value={type.value}
                  id={`${type.value}`}
                  label={t(type.label)}
                  checked={vehicleClasses.includes(type.value)}
                  onChange={e => onSelect('vehicleClasses')(e.target.value)}
                />
              ))}
            </div>
          </div>
          <div className="filters_item">
            <h3>{t('passengers')}</h3>
            <div>
              {passengers.map(passenger => (
                <Checkbox
                  id={passenger.label}
                  key={passenger.value}
                  value={passenger.value}
                  label={passenger.label}
                  checked={passengersFilter.includes(passenger.value)}
                  onChange={e => onSelect('passengers')(+e.target.value)}
                />
              ))}
            </div>
          </div>
          <div className="filters_item">
            <Select
              options={[
                {
                  value: 'manual',
                  label: t('transmissionManual'),
                },
                {
                  value: 'automatic',
                  label: t('transmissionAutomatic'),
                },
              ]}
              value={transmission}
              placeholder={t('all')}
              label={t('transmission')}
              className="select_wrapper"
              onChange={e => onSelect('transmission')(e.target.value)}
            />
          </div>
        </div>
      </aside>
    </div>
  )
}

interface ICheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string
}

const Checkbox = React.forwardRef<HTMLInputElement, ICheckboxProps>(
  ({ label, name, ...rest }, ref) => {
    return (
      <div className="checkbox">
        <input ref={ref} type="checkbox" {...rest} name={name} />
        {label && <label htmlFor={rest.id}> {label} </label>}
      </div>
    )
  },
)

Checkbox.displayName = 'Checkbox'
